import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 left-0 w-full h-full flex align-items-center justify-content-center bg-black-alpha-90",
  style: {"z-index":"9999"}
}
const _hoisted_2 = { class: "text-center text-white p-5 w-30rem max-w-full" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "flex align-items-center justify-content-center gap-4 text-5xl mt-4" }
const _hoisted_5 = { class: "text-lg m-0 font-medium text-200" }


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleChangeOverlay',
  props: {
    visible: {
        type: Boolean,
        default: false,
    },
    oldRoleIcon: {
        type: String,
        default: "pi pi-user",
    },
    newRoleIcon: {
        type: String,
        default: "pi pi-user",
    },
    message: {
        type: String,
        default: "",
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "pi pi-spin pi-spinner text-primary text-6xl block mb-4" }, null, -1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("i", {
                  class: _normalizeClass([__props.oldRoleIcon, "text-400"])
                }, null, 2),
                _cache[0] || (_cache[0] = _createElementVNode("i", { class: "pi pi-arrow-right text-primary" }, null, -1)),
                _createElementVNode("i", {
                  class: _normalizeClass([__props.newRoleIcon, "text-primary"])
                }, null, 2)
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-3xl font-bold mb-3 text-primary" }, "Alternando Perfil", -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(__props.message), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})